import type { OreGradeState, CapacityRead } from '@/versions/v1/schema/capacity';
import { arsenicBadges, gradeControls } from './GradeStrip.transform';
import { CapacityRange } from './CapacityRange';

/** The comp's feed-ore strip: one row of four grade sliders and the As assay badges. */
export function GradeStrip({
  grade,
  measured,
  read,
  onChange,
}: {
  grade: OreGradeState;
  measured: OreGradeState;
  read: CapacityRead;
  onChange: (next: OreGradeState) => void;
}) {
  const controls = gradeControls(grade, measured);
  const badges = arsenicBadges(read);

  return (
    <section
      id="walkthrough-capacity-grade"
      aria-label="Ore grade inputs"
      className="card-matte-2 grid items-center gap-x-[18px] gap-y-3 rounded-[14px] px-3.5 py-2.5 sm:grid-cols-2 xl:grid-cols-[auto_repeat(4,minmax(0,1fr))_auto]"
    >
      <span className="text-xs font-semibold uppercase tracking-[0.07em] text-muted">Feed ore</span>
      {controls.map((control) => (
        <CapacityRange
          key={control.key}
          label={control.label}
          display={control.display}
          min={control.min}
          max={control.max}
          step={control.step}
          value={control.toInput(control.value)}
          minLabel={control.minLabel}
          maxLabel={control.maxLabel}
          fillPct={control.fillPct}
          moved={control.moved}
          markPct={control.markPct}
          markLabel={control.markLabel}
          onChange={(value) => onChange({ ...grade, [control.key]: control.fromInput(value) })}
        />
      ))}
      <div className="flex flex-wrap justify-end gap-1.5">
        {badges.map((badge) => (
          <span
            key={badge.label}
            className="whitespace-nowrap rounded-full border bg-[var(--surface-2)] px-2 py-px text-xs tabular-nums text-[var(--ink-primary)]"
            style={{
              borderColor: badge.tone === 'danger'
                ? 'var(--state-blocked)'
                : badge.tone === 'warning'
                  ? 'var(--state-warning)'
                  : 'var(--state-online)',
            }}
          >
            {badge.label}
          </span>
        ))}
      </div>
    </section>
  );
}
